// extracted by mini-css-extract-plugin
export default {"slider":"InputSlider_slider__DPsC9","slider__range-tumb":"InputSlider_slider__range-tumb__VL2YB","slider__tickmarks":"InputSlider_slider__tickmarks__VrTq6"};